module.exports = __webpack_public_path__ + "pattern.5dacd004927da04b74e2.png";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/images/pattern.png
// module id = ../../../../../src/assets/custom-styles/images/pattern.png
// module chunks = 1